// extracted by mini-css-extract-plugin
export var formContainer = "_fh-0";
export var message = "_fh-1";